import * as React from "react";
import { Redirect } from 'react-router-dom';
import { textFiltering } from "../const/default";
import useEnabledFeatureFlags from "../hooks/useEnabledFeatureFlags";
import constData from "../const/const.json";

const Login = React.lazy(() =>
  import(/* webpackChunkName: "BellaLogin" */ "../pages/Login/Login")
);
const StoreSearchPage = React.lazy(() =>
  import("../pages/StoreSearchPage/StoreSearchPage")
);

const ServicesPage = React.lazy(() =>
  import("../pages/ServicesPage/ServicesPage")
);

const CalendarPage = React.lazy(() =>
  import("../pages/CalendarPage/CalendarPage")
);

const StylistSelectionPage = React.lazy(() =>
  import("../pages/StylistSelectionPage/StylistSelectionPage")
);
const StylistSelectionCategoryPage = React.lazy(() =>
  import("../pages/StylistSelectionCategoryPage/StylistSelectionCategoryPage")
);

const StylistSelectionCategoryLayout = React.lazy(() =>
  import("../pages/StylistSelectionCategoryLayout/StylistSelectionCategoryLayout")
);

const ExpertStylist = React.lazy(() =>
  import("../pages/ExpertStylist/ExpertStylist")
);

const StoreSelectionPage = React.lazy(() =>
  import("../pages/StoreSelectionPage/StoreSelectionPage")
);

const AppointmentReviewPage = React.lazy(() =>
  import("../pages/AppointmentReviewPage/AppointmentReviewPage")
);

const AppointmentConfirmPage = React.lazy(() =>
  import("../pages/AppointmentConfirmPage/AppointmentConfirmPage")
);
const DashboardPage = React.lazy(() =>
  import("../pages/DashboardPage/DashboardPage")
);
const DashboardPastAppointmentsPage = React.lazy(() =>
  import("../pages/DashboardPastAppointmentsPage/DashboardPastAppointmentsPage")
);

const ServiceSelectionPage = React.lazy(() =>
  import("../pages/ServiceSelectionPage/ServiceSelectionPage")
);

const withoutApptsCalendarPage = React.lazy(() =>
  import("../pages/WithoutApptsCalendarPage/WithoutApptsCalendarPage")
);

const FailedConfirmationPage = React.lazy(() =>
  import("../pages/FailedConfirmationPage/FailedConfirmationPage")
);

const SeriesHandlerPage = React.lazy(() =>
  import("../pages/SeriesHandlerPage/SeriesHandlerPage")
);

const reschedulePage = React.lazy(() =>
  import("../pages/ReSchedulePage/ReSchedulePage")
);
const DeepLinkPage = React.lazy(() =>
  import("../pages/DeepLinkPage/DeepLinkPage")
);
const DeepLinkPageV2 = React.lazy(() =>
  import("../pages/DeepLinkPage/DeepLinkPageV2")
);
const PicknewdatePage = React.lazy(() =>
  import("../pages/PicknewdatePage/PicknewdatePage")
);

const appointmentCard = React.lazy(() =>
  import('../components/AppointmnetCard/AppointmentCard')
);

const WelcomePage = React.lazy(() =>
  import('../pages/WelcomePage/WelcomePage')
);

const HandlerPage = React.lazy(() =>
  import("../pages/HandlerPage/HandlerPage")
);

const ExternalRedirect = ({ to }) => {
  window.location.href = to;
  return null;
};

const StoreSearchRedirect = () => {
  const { featureFlags: { ultastoresearch } } = constData;
  const [{ isEnabled: isUltaStoreSearchEnabled }] = useEnabledFeatureFlags([ultastoresearch]);;

  

  if (isUltaStoreSearchEnabled) {
    return <ExternalRedirect to={textFiltering.storeSearchUrl} />;
  }
  return <StoreSearchPage />;
}

const Routes = [
  {
    path: "/",
    component: DashboardPage,
    exact: true,
    protected: true,
    title: "Welcome to your dashboard"
  },
  {
    path: "/login",
    component:  () => <Redirect to="/welcome" />,
    exact: true,
    protected: false,
    title: "Redirecting...",
  },
  {
    path: "/referral/:shortId",
    component: HandlerPage,
    exact: true,
    protected: false,
    title: "Referrals"
  },
  {
    path: "/series/:promotionId",
    component: HandlerPage,
    exact: true,
    protected: false,
    title: "Series"
  },
  {
    path: "/store/search",
    component: StoreSearchRedirect,
    exact: true,
    stepper: 1,
    protected: true,
    title: "Search for a store"
  },
  {
    path: "/store/selection",
    component: StoreSelectionPage,
    exact: true,
    stepper: 1,
    protected: true,
    title: "Welcome to your dashboard"
  },
  {
    path: "/services",
    component: ServicesPage,
    exact: true,
    stepper: 2,
    protected: true,
    title: "Select a service"
  },
  {
    path: "/services/:serviceName",
    component: ServiceSelectionPage,
    exact: true,
    stepper: 2,
    protected: true,
    title: ""
  },
  {
    path: "/services/detail/:serviceName",
    component: ServiceSelectionPage, //<-- TODO Update to point to new service detail page in future
    exact: true,
    protected: true,
    title: ""
  },
  {
    path: "/calendar/browse",
    component: CalendarPage,
    stepper: 3,
    title: "Select a date",
    routes: [
      {
        path: "/calendar/browse/week",
        component: CalendarPage,
        title: "Select a date"
      },
      {
        path: "/calendar/browse/month",
        component: CalendarPage,
        title: "Select a date"
      },
    ],
    protected: true,
  },
  {
    path: "/booking/dates/search/stylist",
    component: withoutApptsCalendarPage,
    exact: true,
    stepper: 4,
    protected: true,
    title: "Search stylist"
  },
  {
    path: "/booking/date/reselect",
    component: FailedConfirmationPage,
    exact: true,
    stepper: 4,
    protected: true,
    title: "Select a booking date"
  },
  {
    path: "/picknewdate",
    component: PicknewdatePage,
    protected: true,
    title: "Select a new date"
  },
  {
    path: "/booking/reschedule/:apptid",
    component: reschedulePage,
    exact: true,
    stepper: 4,
    protected: true,
    title: "Reschedule your appointment"
  },
  {
    path: "/rebook/bookagain/booking/rebook/:apptid",
    component: reschedulePage,
    exact: true,
    protected: true,
    title: "Re-book your appointment"
  },
  {
    path: "/stylist/selection",
    component: StylistSelectionPage,
    exact: true,
    stepper: 4,
    protected: true,
    title: "Select a stylist"
  },
  {
    path: "/stylist/services",
    component: StylistSelectionCategoryPage,
    exact: true,
    protected: true,
    title: "Select a service"
  },
  {
    path: "/stylist/services/:serviceName",
    component: StylistSelectionCategoryLayout,
    exact: true,
    protected: true,
    title: ""
  },
  {
    path: "/stylist/listing",
    component: ExpertStylist,
    exact: true,
    stepper: 4,
    protected: true,
    title: "Select a stylist"
  },
  {
    path: "/appointment/review",
    component: AppointmentReviewPage,
    exact: true,
    stepper: 5,
    protected: true,
    title: "Review your Appointment"
  },
  {
    path: "/appointment/confirm",
    component: AppointmentConfirmPage,
    exact: true,
    protected: true,
    title: "Appointment confirmed"
  },
  {
    path: "/dashboard",
    component: DashboardPage,
    exact: true,
    protected: true,
    title: "Welcome to your dashboard"
  },
  {
    path: "/dashboard/pastappointments",
    component: DashboardPastAppointmentsPage,
    exact: true,
    protected: true,
    title: "Your past appointments"
  },
  {
    path: "/bella/deeplink",
    component: DeepLinkPageV2,
    exact: true,
    protected: false,
    title: "Redirecting you..."
  },
  {
    path:'/appointmentCard',
    component:appointmentCard,
    exact: true,
    protected: true,
    title: "Your appointment"
  },
  {
    path: "/welcome/referral/:shortId",
    component: WelcomePage,
    exact: true,
    protected: false,
    title: "Welcome"
  },
  {
    path: "/welcome/series/:promotionId",
    component: WelcomePage,
    exact: true,
    protected: false,
    title: "Welcome"
  },
  {
    path: "/welcome",
    component: WelcomePage,
    exact: true,
    protected: false,
    title: "Welcome"
  }
];
export default Routes;
